module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185546.3d416885.jpg";